import { useMemo } from 'react';
import { GetCurrencyWithoutSymbol, FormatCurrency } from '@Components/Utilities/CurrencyFormatter';

const AutoBidIncrements = (props) => {

    const bidIncrementRanges = useMemo(() => props?.AutoBidIncrementRanges, []);
    const decimalMaxValue = 79228162514264337593543950335;

    return (
        <table id="increment-table">
            <tbody>
                <tr>
                    <th>{translator.translate('sandhills.currentbid')}</th>
                    <th>{translator.translate('sandhills.tradepubwebsite.mvc.bidincrement')}</th>
                </tr>
                {bidIncrementRanges && bidIncrementRanges.map((range, index) => (
                    <tr key={index} className={range.BidIncrementValue == props?.HighlightedBidIncrement ? 'selected-row' : ''} >
                        <td>{FormatCurrency(range.MinimumBidDisplay, props.CultureCode, props.CurrencyCode)}{range.MaxBidValue === decimalMaxValue ? "+" : " - " + FormatCurrency(range.MaxBidDisplay, props.CultureCode,props.CurrencyCode)}</td>
                        <td>{FormatCurrency(range.BidIncrementDisplay, props.CultureCode,props.CurrencyCode)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default AutoBidIncrements;